import React from "react";
import { Link } from "gatsby";
import Container from "./Container";
import CharityCard1 from "../images/charity/Pattaya-image.webp"; 
import CharityCard2 from "../images/charity/cccf.jpg";
import CharityCard3 from "../images/charity/cool-earth.jpg";
import CharityCard4 from "../images/charity/fishermans-rest.jpg";
import CharityCard5 from "../images/charity/Lebanon-Header-copy.jpg";
import CharityCard6 from "../images/charity/red-crescent.jpg";
import CharityCard7 from "../images/charity/Punchi-Muthi-Pre-School1.jpg"; 

const charityActivities = [
    {
        title: "Fundraising for Pattaya Orphanage",
        image: CharityCard1,
        description: "Our team in Asia have been busy running a popular charity golf league over the past few years to raise money for the local Pattaya Orphanage.",
        link: "/about/charity/pattaya-orphanage/",
    },
    {
        title: "Courage Compassion Commitment Foundation",
        image: CharityCard2,
        description: "Holborn Assets is proud to support the Courage Compassion Commitment (CCC) Foundation, a not-for-profit organisation that supports those most in need.",
        link: "/about/charity/cccf/",
    },
    {
        title: "Cool Earth",
        image: CharityCard3,
        description: "Our interns successfully conquered The Rally, a 10,000+ mile drive across Europe and Asia, to raise money for the environmental charity Cool Earth.",
        link: "/about/charity/cool-earth/",
    },
    {
        title: "Fisherman’s Rest",
        image: CharityCard4,
        description: "Holborn are proud to support Fisherman's Rest, a social project which helps children in Malawi and carries out work such as school building projects.",
        link: "/about/charity/fishermans-rest/",
    },
    {
        title: "Holborn Assets sends support to Lebanon",
        image: CharityCard5,
        description: "Holborn Assets have offered their support to those affected by the tragedy in Beirut. The Dubai-based firm has teamed up with several local charities to help those most in need.",
        link: "/about/charity/disaster-relief/",
    },
    {
        title: "Red Crescent and Education 4 All",
        image: CharityCard6,
        description: "Holborn Assets has joined forces with the Emirates Red Crescent to provide education and school supplies for Syrian and Yemeni refugee children.",
        link: "/about/charity/red-crescent/",
    },
    {
        title: "Punchi Muthi Pre-School",
        image: CharityCard7,
        description: "The Punchi Muthi Pre-School in Sri Lanka offers school-readiness education to children from underprivileged families and teaches valuable life skills.",
        link: "/about/charity/punchi-muthi-pre-school",
    },
];

const ArrowRightIcon = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
        aria-hidden="true"
    >
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
    </svg>
);

function CharityCard({ activity }) {
    return (
        <Link
            to={activity.link}
            aria-label={`${activity.title} – ${activity.description}`}
            className="col-span-1 group focus:outline-none w-[420px] max-w-[92vw] md:w-[350px] lg:w-[460px] md:max-w-none"
        >
            {/* Image Card: Reduced Height and simplified styling */}
            <div
                className="relative h-[300px] rounded-3xl bg-cover bg-center overflow-hidden ring-0 transition-shadow duration-300 group-focus-visible:ring-4 group-focus-visible:ring-holborn-mid-blue/40"
                style={{ backgroundImage: `url(${activity.image})` }}
            >
                <span className="sr-only">{activity.title} background image</span>
            </div>

            {/* Content Below Card */}
            <div className="pt-4 flex items-center justify-between">
                <div className="text-left">
                    <h3 className="text-xl font-bold text-holborn-blue group-hover:text-holborn-mid-blue transition duration-200 mb-1">{activity.title}</h3>
                    <p className="text-sm text-gray-700">{activity.description}</p>
                </div>

                {/* Arrow Icon Next to Text */}
                <div className="p-2 rounded-full text-holborn-mid-blue transition duration-300 ease-in-out group-hover:translate-x-1">
                    <ArrowRightIcon className="h-6 w-6" />
                </div>
            </div>
        </Link>
    );
}

export default function CharityCards() {
    return (
        <Container>
            <div className="pb-16 md:pb-20">
                <div
                    className="grid gap-x-6 gap-y-12 md:gap-x-8 justify-center grid-cols-[repeat(1,max-content)] md:grid-cols-[repeat(2,max-content)] lg:grid-cols-[repeat(3,max-content)]"
                >
                    {charityActivities.map((activity) => (
                        <CharityCard key={activity.link} activity={activity} />
                    ))}
                </div>
            </div>
        </Container>
    );
}